/* eslint-disable react/prop-types */
import { useState } from "react";
import { colors, strCode } from "../../../../consts";
import { dateUtil, deviceUtil } from "../../../../utils";
import { CellWrapper } from "../../../../components/Table/styled";
import {
  DeviceInfo,
  FlexContainers,
  GradientLoader,
  Paragraph2,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../../components";
import { t } from "../../../../services";

export const DeviceCertificatesColumns = [
  {
    Header: "#",
    accessor: "index",
    Cell: ({ cell }) => (
      <CellWrapper width={`fit-content`}>
        <Paragraph2>
          <b>{cell.value}</b>
        </Paragraph2>
      </CellWrapper>
    )
  },
  {
    Header: strCode.DEVICE_TITLE,
    accessor: "device_model",
    Cell: ({ cell, isLoading }) => {
      const [isImageLoaded, setIsImageLoaded] = useState(false);
      const [deviceImage, setDeviceImage] = useState();

      const record = cell?.row?.original;
      const isMercuryDevice = record?.isMercuryDevice;

      deviceUtil.getDeviceImageAsset(record?.deviceImage, isMercuryDevice).then((res) => {
        setDeviceImage(res);
      });

      return (
        <CellWrapper width={`${200}px`}>
          <DeviceInfo
            isLoading={isLoading}
            isImageLoaded={isImageLoaded}
            imageSrc={deviceImage}
            setIsImageLoaded={setIsImageLoaded}
            model={record.device_model}
            type={record.type}
            width={200}
          />
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.SERIAL_NUMBER_TITLE,
    accessor: "dusn",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper maxWidth={`${280}px`}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={210} height={24} animationDuration={40} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.CERTIFICATE_CREATED_BY_TITLE,
    id: "createdBy",
    Cell: ({ cellWidth8, cell }) => {
      const record = cell?.row?.original;
      const { createdBy, createdTs } = record ?? {};

      const author = `${createdBy?.firstName} ${createdBy?.lastName}`;
      let timestamp = null;

      try {
        const date = dateUtil.getUTCDate(new Date(createdTs * 1000));
        timestamp = date?.getTime();
      } catch (e) {
        timestamp = null;
      }

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <WrapperContainer Container={FlexContainers.FlexColumn} gap={4} alignItems="start">
            {author && timestamp ? (
              <>
                <TextOverflowWrapper>{author}</TextOverflowWrapper>

                <TextOverflowWrapper style={{ color: colors.RAISIN_70, fontSize: "14px" }}>
                  {dateUtil.formatDateFromTimestamp(timestamp)}
                </TextOverflowWrapper>
              </>
            ) : (
              <TextOverflowWrapper>{t(strCode.EMPTY_CELL_INFO)}</TextOverflowWrapper>
            )}
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.CERTIFICATES_VALID_UNTIL,
    id: "expirationDate",
    Cell: ({ cell, cellWidth8 }) => {
      const record = cell?.row?.original;
      const { expirationDate } = record ?? {};

      let timestamp = null;

      try {
        const date = dateUtil.getUTCDate(new Date(expirationDate * 1000));
        timestamp = date?.getTime();
      } catch (e) {
        timestamp = null;
      }

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <WrapperContainer Container={FlexContainers.FlexColumn} gap={4} alignItems="start">
            <TextOverflowWrapper style={{ color: colors.RAISIN_70, fontSize: "14px" }}>
              {timestamp ? dateUtil.formatDateFromTimestamp(timestamp) : t(strCode.EMPTY_CELL_INFO)}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  }
];
